import React from 'react';
import { Logo } from '../Logo';

interface SidebarHeaderProps {
  isCollapsed: boolean;
  onToggleCollapse: () => void;
}

export const SidebarHeader: React.FC<SidebarHeaderProps> = ({ isCollapsed, onToggleCollapse }) => {
  return (
    <div className="flex items-center justify-between p-4 border-b border-border h-[64px]">
      {!isCollapsed && (
        <div className="flex-1">
          <Logo variant="small" />
        </div>
      )}
      <button
        onClick={onToggleCollapse}
        className="p-1 rounded hover:bg-surface transition-colors"
        aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      >
        <svg
          className="w-5 h-5 text-text-secondary"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          {isCollapsed ? (
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13 5l7 7-7 7M5 5l7 7-7 7"
            />
          ) : (
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M11 19l-7-7 7-7m8 14l-7-7 7-7"
            />
          )}
        </svg>
      </button>
    </div>
  );
};
